
ko.bindingHandlers.visibleAnim = {
    update: function (element, valueAccessor) {
        if (ko.unwrap(valueAccessor())) {
            //$(element).removeClass('hide-anim');
            $(element).addClass('show-anim');
        } else {
            $(element).removeClass('show-anim');
            //$(element).addClass('hide-anim');
        }
    }
};